import { css } from 'styled-components';
import constants from '../../../constants/globalConstants';
import { getOverrideBackground } from '../../../utils/utilityFunction';
var background;
export default css(["", ";&.nva-50-50{", "}"], function (props) {
  var _props$theme2;
  var _ref = props.fiftyFiftyData || {},
    backgroundTheme = _ref.backgroundTheme,
    overrideBackground = _ref.overrideBackground;
  var themeBgColor;
  if (overrideBackground !== null && overrideBackground !== void 0 && overrideBackground.colorBackground) {
    themeBgColor = overrideBackground.colorBackground;
  } else {
    var _props$theme;
    var _ref2 = ((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.fiftyFiftyCard) || {},
      bgColorLight = _ref2.bgColorLight,
      bgColorDark = _ref2.bgColorDark;
    themeBgColor = backgroundTheme === constants.dark ? bgColorDark : bgColorLight;
  }
  background = getOverrideBackground({
    entry: overrideBackground,
    themeBgColor: themeBgColor,
    colorPalette: (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.palette
  });
  return background.css;
}, function () {
  return background.css;
});